import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AirRoutingModule } from './air-routing.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ApiRequestInterceptor, ApiResponseInterceptor, ApiErrorInterceptor, ApiEmptyResponseInterceptor } from './modules/common/interceptor';
import { AirUserSettingsResolver } from './modules/common/resolver/air-user-settings.resolver';
import { AppCommonModule, PrimengModule } from './modules';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    AppCommonModule,
    PrimengModule,
    AirRoutingModule
  ],
  providers: [
    AirUserSettingsResolver,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiRequestInterceptor,
      multi: true,
  },
  {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiResponseInterceptor,
      multi: true,
  },
  {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiErrorInterceptor,
      multi: true,
  },
  {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiEmptyResponseInterceptor,
      multi: true,
  },
  ],
  exports: [AppCommonModule]
})
export class AirModule { }
